import React from "react";
import {Modal, Image, Spin} from "antd";
import PdfDrawer from "src/components/pdfDrawer";
import {getDownloadUrl} from "./fileManagerApi";

const IMAGE_TYPES = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
const PDF_TYPES = ["pdf"];

class FilePreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      blobUrl: null,
      loading: true,
    };
  }

  componentDidMount() {
    this.loadFile();
  }

  componentWillUnmount() {
    if (this.state.blobUrl) {
      URL.revokeObjectURL(this.state.blobUrl);
    }
  }

  loadFile = () => {
    const {file} = this.props;
    if (!file) return;

    const token = localStorage.getItem("adv_stats");
    fetch(getDownloadUrl(file.path), {
      headers: {Authorization: `Bearer ${token}`},
    })
      .then((res) => {
        if (!res.ok) throw new Error("Erreur de chargement");
        return res.blob();
      })
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        this.setState({blobUrl, loading: false});
      })
      .catch(() => {
        this.setState({loading: false});
      });
  };

  render() {
    const {file, onClose} = this.props;
    const {blobUrl, loading} = this.state;

    if (!file) return null;

    const fileType = (file.type || "").toLowerCase();

    if (loading) {
      return (
        <Modal visible={true} footer={null} onCancel={onClose} width={400}>
          <div style={{textAlign: "center", padding: 40}}>
            <Spin size="large" tip="Chargement..." />
          </div>
        </Modal>
      );
    }

    if (!blobUrl) {
      onClose();
      return null;
    }

    if (PDF_TYPES.includes(fileType)) {
      return (
        <PdfDrawer
          filePath={blobUrl}
          fileName={file.name}
          onPdfClose={onClose}
        />
      );
    }

    if (IMAGE_TYPES.includes(fileType)) {
      return (
        <Modal
          visible={true}
          title={file.name}
          footer={null}
          onCancel={onClose}
          width={800}
        >
          <div style={{textAlign: "center"}}>
            <Image
              src={blobUrl}
              alt={file.name}
              style={{maxWidth: "100%", maxHeight: "70vh"}}
            />
          </div>
        </Modal>
      );
    }

    onClose();
    return null;
  }
}

export default FilePreview;
